import { useContext } from 'react';
import { RootStoreContext } from './RootStoreContext';
import { RootStore } from '../mobx/stores/root-store';

/** Don't forget to wrap your component in an observer() when using this hook */
export const useStores = (): RootStore => useContext(RootStoreContext);
